import { SxProps, Theme } from "@mui/material";

export {
  buttonsContainerStyles,
  dayStyles,
  errorTypographyStyles,
  fieldContainerStyles,
  fieldsGridStyles,
  getInputLabelStyles,
  getSelectStyles,
  getTextFieldStyles,
  jsonTextFieldStyles,
  layoutStyles,
  mainButtonStyles,
  menuItemStyles,
  modalBoxStyles,
  popperStyles,
  presetMenuPaperStyles,
  secondaryButtonStyles,
  successTypographyStyles,
  yearButtonStyles,
} from "../upload-assessment-modal/styles";

export {
  contestItemStyles,
  contestMetaTypographyStyles,
  contestTitleTypographyStyles,
  emptyListTypographyStyles,
  hintTypographyStyles,
  listContainerStyles,
  listLoadingStyles,
} from "../delete-contest-modal/styles";

export const headerTypographyStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.modalColors.headerColor,
});

export const selectedHintStyles: SxProps<Theme> = (theme) => ({
  fontFamily: "Red Hat Display",
  color: theme.palette.adminPanel.textColor,
  opacity: 0.8,
  margin: 0,
});
